import styled from 'styled-components';
import COLORS from 'lib/constants/colors';

const ErrorMessage = styled.p`
  font-size: 12px;
  color: ${COLORS.pink};
  margin-top: 8px;
  display: block;
  position: relative;
  user-select: none;
`;

export default ErrorMessage;
